import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'
import type { DashboardRange } from '@schemas'

/** 백오피스 홈(/main/home) 대시보드. 스태프 토큰 · 서버가 adminGuard 로 막는다 */
export const getDashboardSummary = async ({
	query = { range: '7d' } as { range: DashboardRange },
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'get',
			uri: '/dashboard/summary',
			query: query,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** GA4 요약 — 서버가 읽고 캐시한 값. 브라우저는 GA 를 직접 부르지 않는다 */
export const getDashboardAnalytics = async ({
	query = { range: '7d' } as { range: DashboardRange },
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'get',
			uri: '/dashboard/analytics',
			query: query,
			customHeaders: customHeaders,
		})
		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const dashboardApi = {
	getDashboardSummary,
	getDashboardAnalytics,
}

export default dashboardApi
